import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { DetailsTab, SitesTab, UsersTab, FilesTab } from "./Components";
import { ArrowLeft } from "lucide-react";
import { useProjects } from "./Hooks/useProjects";

const ProjectDetailsPage = () => {
  const { instanceId } = useParams();
  const { projectDetails, fetchProjectDetails, saveProjectDetails, loading } =
    useProjects({
      projectId: instanceId,
    });
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjectDetails({ project: "all" });
  }, [instanceId]);

  return (
    <div className="p-2 h-full">
      <div className="space-y-2">
        <div>
          <div className="flex gap-2 py-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="text-primary text-center text-sm font-lg"
            >
              <ArrowLeft
                size={25}
                absoluteStrokeWidth
                className="text-primary"
              />
            </button>
            <h1 className="text-2xl font-bold">Project Details</h1>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-10 gap-3 px-2 h-full pb-4">
          <div className="flex flex-col gap-3 md:col-span-7 h-full">
            <div className="bg-white border border-gray-200 shadow-md p-3 flex-shrink-0">
              {projectDetails && (
                <DetailsTab
                  projectDetails={projectDetails}
                  saveProjectDetails={saveProjectDetails}
                  loading={loading}
                />
              )}
            </div>

            <div className="bg-white border border-gray-200 shadow-md p-3 pb-0 flex-1 overflow-hidden h-full">
              <div className="h-full min-h-[35vh] max-h-[40h] overflow-y-auto">
                <SitesTab projectId={instanceId} />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 md:col-span-3 h-full">
            <div className="bg-white border border-gray-200 shadow-md p-3 flex-1 overflow-hidden">
              <div className="h-full min-h-[25vh] max-h-[50vh] overflow-y-auto">
                <UsersTab projectId={instanceId} />
              </div>
            </div>

            <div className="bg-white border border-gray-200 shadow-md p-3 pb-0 flex-1 overflow-hidden">
              <div className="h-full min-h-[25vh] max-h-[55vh] overflow-y-auto">
                <FilesTab projectId={instanceId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsPage;
